var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Container',{attrs:{"fluid":""}},[_c('div',{staticClass:"d-flex flex-wrap station-list-view",staticStyle:{"gap":"14px"}},_vm._l((_vm.stations),function(station){return _c('div',{key:station.id,attrs:{"cols":"12"}},[_c('StationItem',{attrs:{"station":station,"distance":_vm.getDistance(station.coordinates, station),"view":true}})],1)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }